import { useState } from 'react';
import { cn } from '@/modules/cn';
import { useAssetLogo } from '@/modules/asset-logo';

// spothq is unmaintained (pre-2021 coins only), so it is never a primary
// source; the letters badge is the terminal fallback — a missing logo must
// never render as blank space. While the SanAPI lookup is in flight the
// badge shows instead of firing a doomed spothq request for post-2021
// assets.
export default function CoinIcon({
  asset,
  slug,
  logoUrl,
  size,
  className,
}: {
  asset: string;
  slug?: string | null | undefined;
  logoUrl?: string | null | undefined;
  size: number;
  className?: string | undefined;
}) {
  const [failed, setFailed] = useState<string[]>([]);
  const serverSrc = logoUrl != null && logoUrl !== '' ? logoUrl : null;
  const serverHealthy = serverSrc !== null && !failed.includes(serverSrc);
  const sanLogo = useAssetLogo({
    ticker: asset,
    ...(slug !== undefined && { slug }),
    enabled: !serverHealthy,
  });
  const candidates = [
    serverSrc,
    sanLogo.url,
    ...(sanLogo.resolving ?
      []
    : [
        `https://cdn.jsdelivr.net/gh/spothq/cryptocurrency-icons/32/color/${asset.toLowerCase()}.png`,
      ]),
  ];
  const src = candidates.find(
    (u): u is string => u !== null && !failed.includes(u),
  );

  if (src === undefined) {
    return (
      <span
        className={cn(
          'flex shrink-0 items-center justify-center rounded-full bg-purple-01 font-bold text-purple-default',
          className,
        )}
        style={{
          width: size,
          height: size,
          fontSize: Math.max(7, Math.round(size * 0.38)),
          lineHeight: 1,
        }}
      >
        {asset.slice(0, 2).toUpperCase()}
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={asset}
      loading="lazy"
      className={cn('shrink-0 rounded-full', className)}
      style={{ width: size, height: size }}
      onError={() => {
        setFailed((f) => (f.includes(src) ? f : [...f, src]));
      }}
    />
  );
}
